__turbopack_context__.v({
  "actions": "VlzbAG_actions",
  "amountChip": "VlzbAG_amountChip",
  "cancelButton": "VlzbAG_cancelButton",
  "chip": "VlzbAG_chip",
  "chipGroup": "VlzbAG_chipGroup",
  "currencyChip": "VlzbAG_currencyChip",
  "currencyChipLabel": "VlzbAG_currencyChipLabel",
  "iconWrapper": "VlzbAG_iconWrapper",
  "label": "VlzbAG_label",
  "presetCard": "VlzbAG_presetCard",
  "sendIcon": "VlzbAG_sendIcon",
  "submitButton": "VlzbAG_submitButton",
});
